export default "__VITE_ASSET__jNBDzDUK__"